import styled from "styled-components";

export const Container = styled("div")<{ $backgroundImage: string }>`
	position: absolute;
	top: 2.4em;
	right: 0.15em;
	width: 5.5em;
	height: 5.5em;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	background-image: url(${(props) => props.$backgroundImage});
	background-size: cover;
	//transform: rotate(-21deg);
	color: #fff;
	font-family: "Baloo";
	font-size: 0.85em;

	-webkit-text-stroke-width: 0.22em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;

	animation: scalerotate 2s infinite;

	@keyframes scalerotate {
		0% {
			transform: scale(1) rotate(30deg);
		}
		50% {
			transform: scale(1.2) rotate(20deg);
		}
		100% {
			transform: scale(1) rotate(30deg);
		}
	}
`;

export const Text = styled.span`
	margin-bottom: 0.5em;
	position: relative;

	span {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 1;
		//animation: fadeInText 4s infinite;
	}

	span.text {
		font-size: 1.4em;
		line-height: 1em;
	}

	span.text2 {
		font-size: 1.4em;
		line-height: 1em;
		animation-delay: 2s;
	}

	@keyframes fadeInText {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 0;
		}
		75% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;
